import { Component, ElementRef, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';

import { PlatformService } from 'app/core/services/platform.service';

@Component({
  standalone: false,
  selector: 'pptl-main-layout',
  templateUrl: 'main-layout.component.html',
  styleUrls: ['../layout-component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MainLayoutComponent implements OnInit{
  constructor(
    private platformService: PlatformService,
    private renderer: Renderer2,
    private el: ElementRef
  ) {}

  ngOnInit() {
    if (this.platformService.isAndroid()) {
      this.renderer.addClass(this.el.nativeElement, 'is-android');
    }
  }

  get isDevicePlatform(): boolean {
    return false;
  }

  get isDesktop(): boolean {
    return true;
  }
}
